import type { Phase, Step } from "../interfaces/types";

export interface Flow {
  readonly state: { step: Step; phase: Phase };
  capture: () => void;
  accept: () => void;
  retry: () => void;
  reset: () => void;
}

const NEXT_STEP: Record<Step, Step> = { FRONT: "BACK", BACK: "DONE", DONE: "DONE" };

export const createFlow = (): Flow => {
  let step: Step = "FRONT";
  let phase: Phase = "CAPTURING";

  return {
    get state() {
      return { step, phase };
    },
    capture: () => {
      if (step !== "DONE" && phase === "CAPTURING") phase = "REVIEWING";
    },
    accept: () => {
      if (phase !== "REVIEWING") return;
      step = NEXT_STEP[step] ?? "DONE";
      phase = step === "DONE" ? "REVIEWING" : "CAPTURING";
    },
    retry: () => {
      if (phase === "REVIEWING" && step !== "DONE") phase = "CAPTURING";
    },
    reset: () => {
      step = "FRONT";
      phase = "CAPTURING";
    },
  };
};
